import type { TDatadogErrorLog } from 'utils/datadog/types'

export const GET_BRAND_QUERY_ERROR_LOG: TDatadogErrorLog = {
  from: 'src/modules/brands/common/hooks/use-brand-query/index.ts',
  name: 'Get Brand Query',
  message: 'Failed to fetch brand query data',
}
